import { Color } from "../enums/Color";

export const candidateEmailUnsubscribePage = {
    mobile: {
        content: {
            display: "block",
            textAlign: "center",
            margin: "24.1vw 0"
        },
        button: {
            border: "none",
            backgroundColor: Color.Green,
            color: Color.White,
            borderRadius: "2.41vw",
            width: "60vw",
            height: "12.07vw",
            padding: "1.67vh",
            fontSize: "4.35vw",
            fontWeight: "bold" as "bold",
            boxShadow: "2.42vw 2.42vw 6.04vw #00000029"
        },
        messageSuccess: {
            color: Color.Green
        },
        messageWarning: {
            color: Color.Red
        }
    },
    desktop: {
        content: {
            margin: "7.81vw 0"
        },
        button: {
            width: "18.125vw",
            height: "3.64vw",
            fontSize: "1.04vw",
            padding: "2.12vh",
            borderRadius: "0.52vw",
            boxShadow: "0.52vw 0.52vw 1.30vw #00000029"
        }
    }
}